import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-702cbd6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "file_present", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_indicator = _resolveComponent("message-indicator")!
  const _component_message = _resolveComponent("message")!

  return (_openBlock(), _createBlock(_component_message, {
    message: _ctx.message,
    class: "file-message"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["file-bubble", [_ctx.message.sender]]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openInNewTab()))
      }, [
        _hoisted_1,
        _createElementVNode("span", null, _toDisplayString(_ctx.message.content.name || "Unbenannte Datei "), 1),
        _createVNode(_component_message_indicator, { message: _ctx.message }, null, 8, ["message"])
      ], 2)
    ]),
    _: 1
  }, 8, ["message"]))
}